module.exports = __webpack_public_path__ + "static/media/drawer-button-open.16b1370c.svg";